import { Component } from '@angular/core';
import { SaasSettingsComponent as AbpSaasSettingsComponent } from '@volo/abp.ng.saas/config';

@Component({
    selector: 'ca-saas-setting-group',
    templateUrl: './saas-setting-group.component.html',
    styleUrl: './saas-setting-group.component.scss',
    standalone: false
})
export class SaasSettingGroupComponent {
  abpSaasSettingGroup = AbpSaasSettingsComponent;
}
